import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Summary within the rectangular source home. The stored summary may be
 * generated or user-edited; it is not a quotation from the original source.
 * Back to source belongs on the step view, outside this tile.
 */
export const DrawerSourceTile: React.FC<{
    summary: string;
}> = ({ summary }) => (
    <Box sx={{ px: 2, pt: 1 }}>
        <Box
            data-testid="WB_DRAWER_SOURCE_TILE"
            sx={{
                border: '1px solid rgba(var(--color-accent-rgb), 0.45)',
                bgcolor: 'var(--color-accent-muted)',
                borderRadius: 2,
                px: 1.5,
                py: 1.25,
                maxHeight: '9rem',
                overflowY: 'auto',
            }}
        >
            <Typography
                component="p"
                sx={{
                    m: 0,
                    fontSize: '0.625rem',
                    fontWeight: 700,
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    color: 'var(--color-accent-text)',
                }}
            >
                Summary
            </Typography>
            <Typography
                component="p"
                sx={{
                    m: 0,
                    mt: 0.75,
                    fontSize: '0.875rem',
                    lineHeight: 1.45,
                    color: 'var(--color-text-primary)',
                    whiteSpace: 'pre-line',
                }}
            >
                {summary}
            </Typography>
        </Box>
    </Box>
);

export const DrawerProvenanceLine: React.FC<{ fact: string }> = ({ fact }) => (
    <Typography
        component="p"
        data-testid="WB_DRAWER_PROVENANCE"
        sx={{
            m: 0,
            px: 2,
            pt: 1.25,
            fontSize: '0.8rem',
            lineHeight: 1.4,
            color: 'var(--color-text-muted)',
        }}
    >
        {fact}
    </Typography>
);
